module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "header": false,
      "customClass": 'heightAuto',
      "footer": false
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "p-4",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('h2', {
    staticClass: "text-center mb-3"
  }, [_vm._v("Rebook reservation for:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex h-100 justify-content-between align-items-center py-4"
  }, [_c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer",
    on: {
      "click": function($event) {
        return _vm.clickedSameProduct()
      }
    }
  }, [_vm._v("Same product")]), _vm._v(" "), _c('div', {
    staticClass: "w-25 d-flex justify-content-center"
  }, [_c('span', [_vm._v(" - OR - ")])]), _vm._v(" "), _c('button', {
    staticClass: "w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer",
    on: {
      "click": function($event) {
        return _vm.clickedOtherProduct()
      }
    }
  }, [_vm._v("Other product")])]), _vm._v(" "), (_vm.isPaymentLinkActive) ? _c('div', [_c('div', {
    staticClass: "border-top-light my-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pt-2"
  }, [_c('p', {
    staticClass: "bold fs-large"
  }, [_vm._v("Please note:")]), _vm._v(" "), _c('p', {
    staticClass: "dark mt-1 text-break"
  }, [_vm._v("When rebooking, the current payment link will be deactivated. A new payment link will be generated and sent by email to the customer.")])])]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-12c589ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c589ba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/RebookChooseProduct.vue
// module id = 1659
// module chunks = 0